import { HintTooltipProperty } from '@/ui-kit/components/tooltip/enum';

// eslint-disable-next-line import/prefer-default-export
export const IconHintTooltipProperty = {
  Header: HintTooltipProperty.Header,
  Message: HintTooltipProperty.Message,
  IconType: 'iconType',
  IconColor: 'iconColor',
  IconSize: 'iconSize',
};
